// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__QmuId","load2":"Spinner_load2__2hr0W"};